var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnsInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#E9ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13C9 10.7909 10.7909 9 13 9H19C21.2091 9 23 10.7909 23 13V19C23 21.2091 21.2091 23 19 23H13C10.7909 23 9 21.2091 9 19V13ZM16 19.5C17.933 19.5 19.5 17.933 19.5 16C19.5 14.067 17.933 12.5 16 12.5C14.067 12.5 12.5 14.067 12.5 16C12.5 17.933 14.067 19.5 16 19.5ZM16 18.3333C17.2887 18.3333 18.3333 17.2887 18.3333 16C18.3333 14.7113 17.2887 13.6667 16 13.6667C14.7113 13.6667 13.6667 14.7113 13.6667 16C13.6667 17.2887 14.7113 18.3333 16 18.3333ZM20.0833 12.5C20.4055 12.5 20.6667 12.2388 20.6667 11.9167C20.6667 11.5945 20.4055 11.3333 20.0833 11.3333C19.7612 11.3333 19.5 11.5945 19.5 11.9167C19.5 12.2388 19.7612 12.5 20.0833 12.5Z",
    fill: "url(#paint0_linear_477_9714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_477_9714",
    x1: 21.25,
    y1: 6.66667,
    x2: 9,
    y2: 25.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#962FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#D6295F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FA7E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927111,
    stopColor: "#EEDDAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsInstagram);
export default __webpack_public_path__ + "static/media/sns_instagram.04b23c6dab46ecaf7e0460a7deda4ff6.svg";
export { ForwardRef as ReactComponent };